document.addEventListener('DOMContentLoaded', function() {
  function constrainGalleryHeight() {
    const galleryList = document.querySelector('.product__media-list');
    if (galleryList) {
      const galleryWidth = galleryList.offsetWidth;
      galleryList.style.maxHeight = galleryWidth + 'px';
      
      // Also constrain individual media items
      const mediaItems = galleryList.querySelectorAll('.product__media-item');
      mediaItems.forEach(item => {
        item.style.maxHeight = galleryWidth + 'px';
      });
    }
  }
  
  // Run on load
  constrainGalleryHeight();
  
  // Run on window resize
  window.addEventListener('resize', constrainGalleryHeight);
  
  // Run when variant changes (in case images change)
  document.addEventListener('variant:change', constrainGalleryHeight);
  
  // Also try listening for common Shopify events
  document.addEventListener('shopify:section:load', constrainGalleryHeight);
  document.addEventListener('shopify:section:reorder', constrainGalleryHeight);
});